
export function generateYearOptions() {
    const currentYear = new Date().getFullYear(); 
    const currentMonth = new Date().getMonth();
    const yearOption = [];
    for (let i = -3; i <= 3; i++) {
        const year = currentYear + i;
        yearOption.push({ value: `${year}-${year + 1}`, label: `${year}-${year + 1}` });
    }
    const defaultSelected = currentMonth < 2 ? `${currentYear - 1}-${currentYear}` : `${currentYear}-${currentYear + 1}`;
    return {yearOption,defaultSelected};
}


export const monthOption = [
    {value:"1",label:"JAN"},
    {value:"2",label:"FAB"},
    {value:"3",label:"MAR"},
    {value:"4",label:"APR"},
    {value:"5",label:"MAY"},
    {value:"6",label:"JUN"},
    {value:"7",label:"JUL"},
    {value:"8",label:"AUG"},
    {value:"9",label:"SEP"},
    {value:"10",label:"OCT"},
    {value:"11",label:"NOV"},
    {value:"12",label:"DEC"},

]
export const expenseOption = [
    {value:"tds",label:"TDS",module:"Tax Deducted at Source (TDS)"},
    {value:"directTax",label:"Direct-Tax",module:"Direct Tax"}
]